import { ArticleExtraData } from "../../../../../../../articlePage/stateInterfaces";
import { OngoingRoofItemMeta } from "../utils/newsFlashUtils";
import { NewsFlashSpecialSlotItem } from "./newsFlashSpecialSlotItem";

interface OngoingRoofEventClusterProps {
    roof: string
    articles: ArticleExtraData[]
    articleIndexes: number[]
    metas: OngoingRoofItemMeta[]
    isLTR: boolean
    languageCode: string
    isFirstInterval: boolean
    highlightingDuration: number
    tickerBottomLink?: string
    tickerBottomTitle?: string
    accordionOpenState?: boolean
    openedItemIndex?: string
    openedItems?: string[]
    onToggleItem?: (id: string) => void
    openMediaDisplayView: (videoIndex: number) => void
    onLiveUpdatesClick: (roof: string) => void
}

const LIVE_UPDATES_LABEL = "לעדכונים שוטפים";

export const OngoingRoofEventCluster = (props: OngoingRoofEventClusterProps) => {
    const { roof, articles, articleIndexes, metas, isLTR, languageCode, isFirstInterval, highlightingDuration,
        tickerBottomLink, tickerBottomTitle, accordionOpenState, openedItemIndex, openedItems,
        onToggleItem, openMediaDisplayView, onLiveUpdatesClick } = props;
    const showFilledDot = metas.some(meta => meta.showFilledRedDot);

    return (
        <div className={`ongoing-roof-event-cluster ${showFilledDot ? "has-filled-dot" : ""}`}>
            {showFilledDot && <div className="ongoing-cluster-filled-dot" aria-hidden="true" />}

            <div className="ongoing-cluster-header">
                <div className="ongoing-cluster-roof">{roof}</div>

                <button type="button" className="ongoing-live-updates-label" onClick={() => onLiveUpdatesClick(roof)}>
                    <span className="label-dot" aria-hidden="true" />
                    <span className="label-text">{LIVE_UPDATES_LABEL}</span>
                </button>
            </div>

            <div className="ongoing-cluster-items">
                {articles.map((article, localIndex) => {
                    const globalIndex = articleIndexes[localIndex];
                    const accordionState = onToggleItem
                        ? (accordionOpenState || article.articleId === openedItemIndex || (openedItems && openedItems.includes(article.articleId)))
                        : accordionOpenState;

                    return (
                        <NewsFlashSpecialSlotItem
                            isLTR={isLTR}
                            nextRoof={null}
                            article={article}
                            previousRoof={null}
                            index={globalIndex}
                            isClusterChild={true}
                            roofOngoingEvent={true}
                            key={article.articleId}
                            languageCode={languageCode}
                            onRowItemToggle={onToggleItem}
                            ongoingMeta={metas[localIndex]}
                            isFirstInterval={isFirstInterval}
                            accordionOpenState={accordionState}
                            tickerBottomLink={tickerBottomLink}
                            tickerBottomTitle={tickerBottomTitle}
                            highlightingDuration={highlightingDuration}
                            openMediaDisplayView={openMediaDisplayView}
                        />
                    );
                })}
            </div>
        </div>
    );
}
